import AgencyHelper from 'features/Agency/agencyHelper';
import { ChargeConstants } from 'features/Charge/chargeHelper';
import FleetHelper from 'features/Fleet/fleetHelper';
import { AppDialogHelper } from 'general/components/AppDialog';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

FleetTopupView.propTypes = {};

function FleetTopupView(props) {
    // MARK: ---- PROPERTIES ----
    const { user } = useSelector((state) => state.auth);
    const [balance, setBalance] = useState(0);
    const isAgency = user?.role === ChargeConstants.UserRole.AGENCY;
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [amount, setAmount] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedBankAccount, setSelectedBankAccount] = useState(null);
    const [bankAccountList, setBankAccountList] = useState([]);
    useEffect(() => {
        if (isAgency) {
            const agencyId = user?.agencyId;
            AgencyHelper.API.requestGetAgencyBankAccountList(agencyId).then((response) => {
                setBankAccountList(response.bankAccounts);
            });
        }
        setBalance(user?.agency?.balance ?? 0);
    }, [user, isAgency]);
    useEffect(() => {
        const defaultBankAccount = _.find(bankAccountList, (item) => item.defaultAccount === 1);
        if (Utils.isValid(defaultBankAccount)) {
            setSelectedBankAccount(defaultBankAccount);
        }
    }, [bankAccountList]);
    const [paymentMethodsList, setPaymentMethodsList] = useState([]);
    const [fundingSource, setFundingSource] = useState('');
    useEffect(() => {
        const handleGetPaymentMethodList = async () => {
            const res = await miscHelper.callApiGetAppConfig();
            if (res) {
                const paymentConfig = res.config.find(item => item.key === "enablePaymentMethods_V2");
                const paymentMethods = JSON.parse(paymentConfig.value);
                setPaymentMethodsList(paymentMethods);
            }
        };

        handleGetPaymentMethodList();
    }, [])
    const baseUrl = window.location.origin;
    // MARK: ---- FUNCTIONS ----
    const handleSubmit = async () => {
        setReadyToValidate(true);
        if (!Utils.isValid(amount)) {
            ToastHelper.showError('Vui lòng nhập số tiền');
            return;
        }
        if (_.toNumber(amount) < 50000) {
            ToastHelper.showError('Số tiền phải lớn hơn hoặc bằng 50.000đ');
            return;
        }
        if (!Utils.isValid(fundingSource)) {
            ToastHelper.showError('Vui lòng chọn phương thức thanh toán');
            return;
        }
        const params = {
            amount,
            fundingSource,
            currency: 'VND',
            redirectUrl: fundingSource === 'VNPAY' ? `${baseUrl}/topup/payment` : ''
        };
        handlePayment(params);
    };

    const handlePayment = async (params) => {
        try {
            const res = await FleetHelper.API.requestFleetTopup(params);
            if (res) {
                const { transaction, payment, qrData, expiryInSeconds, link } = res;
                if (res.result === 'success') {
                    if (link) {
                        window.location.href = link;
                    } else {
                        console.log({ qrData });
                        dispatch(setData(res));
                        router.navigate(`/topup/payment`);
                    }
                } else {
                    ToastHelper.showError(res.reason);
                }
            }
        } catch (error) {
            console.log('error: ', error);
            ToastHelper.showError(error?.response?.data?.reason);
        }
    };

    const getPaymentMethodsLogo = (paymentMethod) => {
        switch (paymentMethod) {
            case 'QR':
                return AppResource.icons.evg.icLogoQR;
            case 'BANK':
                return AppResource.icons.evg.icLogoBank;
            case 'VNPAY':
                return AppResource.icons.evg.icLogoVNPay;
            case 'MOMO':
                return AppResource.icons.evg.icLogoMomo;
        }
    }

    return (
        <div className="px-4 my-4">
            {UIHelper.buildCard(
                <div>
                    <div className="pb-4">
                        {/* header */}
                        <div
                            className="px-4 pt-4 pb-4 d-flex flex-column"
                            style={{
                                borderBottom: `1px solid ${AppColors.gray[300]}`,
                            }}
                        >
                            {/* title */}
                            <div className="d-flex flex-column">
                                <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                                    Nạp tiền vào ví
                                </span>
                            </div>
                            <div className="">
                                <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[900])}>
                                    Số dư ví:{' '}
                                    <span style={UIHelper.buildFontStyle('600', '16px', AppColors.primary)}>
                                        {Utils.formatNumber(balance)} VNĐ
                                    </span>
                                </span>
                            </div>
                        </div>
                        {/* body */}
                        <div className="pt-4">
                            <div
                                className="mt-2 row m-0 p-0 px-2"
                                style={{
                                    borderBottom: `1px dashed ${AppColors.gray[300]}`,
                                }}
                            >
                                <div className="col mb-2 px-2">
                                    {UIHelper.buildFormLabel('Số tiền muốn nạp', true)}
                                    <KTFormInput
                                        type={KTFormInputType.currency}
                                        placeholder="Nhập số tiền"
                                        name="amount"
                                        value={amount}
                                        onChange={(value) => {
                                            setAmount(value);
                                        }}
                                        enableCheckValid={readyToValidate}
                                        isValid={
                                            Utils.isValid(amount) &&
                                            _.toNumber(amount) >= 50000
                                        }
                                        isTouched={true}
                                        feedbackText={
                                            !Utils.isValid(amount)
                                                ? 'Vui lòng nhập số tiền'
                                                : _.toNumber(amount) < 50000
                                                    ? 'Số tiền phải lớn hơn hoặc bằng 50.000đ'
                                                    : ''
                                        }
                                    />
                                    <div className="mt-1">
                                        {UIHelper.buildFormText('Tối thiểu: 50.000 ₫')}
                                    </div>
                                </div>
                            </div>

                            {/* phuong thuc thanh toan */}
                            <div className="p-4" style={{ borderBottom: `1px solid ${AppColors.gray[300]}` }}>
                                <div style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])} className="mb-3">
                                    {UIHelper.buildFormLabel('Chọn phương thức thanh toán', true)}
                                </div>
                                <div className='d-flex flex-column gap-3'>
                                    {paymentMethodsList?.map(item => (
                                        <div
                                            className='p-4 d-flex align-items-center gap-3 rounded-lg cursor-pointer'
                                            style={{ border: fundingSource === item.fundingSource ? `2px solid ${AppColors.primary}` : `1px solid ${AppColors.gray[300]}` }}
                                            onClick={() => setFundingSource(item.fundingSource)}
                                        >
                                            <img src={getPaymentMethodsLogo(item.fundingSource)} width={36} height={36} />
                                            <div style={UIHelper.buildFontStyle('500', '16px', AppColors.gray[800])}>
                                                {item.name}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* actions */}
                            <div className="d-flex align-items-center px-4 mt-4">
                                {UIHelper.buildGreenButton('Xác nhận nạp tiền', handleSubmit, null, false, loading)}
                            </div>
                        </div>
                    </div>
                </div>,
                false
            )}
        </div>
    );
}

export default FleetTopupView;
